import React from 'react';

import { type UseFormReturn } from 'react-hook-form';

import { CURRENCIES } from 'src/features/payStations/types';
import ReservationNameTypeDate from 'src/features/reservations/components/forms/ReservationNameTypeDate.tsx';
import ReservationPricing from 'src/features/reservations/components/forms/ReservationPricing.tsx';
import ReservationStayDetails from 'src/features/reservations/components/forms/ReservationStayDetails.tsx';
import { type CreateReservationTypeFormSchemaValues } from 'src/features/reservations/hooks/useCreateReservationType.ts';
import { useDisplayedFormValues } from 'src/features/reservations/providers/ReservationVersionsProvider.tsx';
import { formatPrice } from 'src/features/reservations/utils/utils.tsx';
import { Form } from 'src/registry/ui/Form.tsx';

interface VersionFormProps {
    form: UseFormReturn<CreateReservationTypeFormSchemaValues>;
    onSubmit: () => void;
}

function VersionForm({ form, onSubmit }: VersionFormProps) {
    const { setDisplayedFormValues } = useDisplayedFormValues();
    const { price, tax_amount, price_with_tax, tax_percent, currency, valid_from } = form.getValues();

    const [selectedFromDate, setSelectedFromDate] = React.useState<Date | undefined>(valid_from);

    React.useEffect(() => {
        setDisplayedFormValues({
            price: price ? formatPrice(price) : '',
            tax_percent: tax_percent ? (parseFloat(tax_percent) * 100).toFixed(2) : '',
            tax_amount: tax_amount ? formatPrice(tax_amount) : '',
            price_with_tax: price_with_tax ? formatPrice(price_with_tax) : '',
            currency: currency ?? CURRENCIES.BGN,
        });
    }, [form]);

    return (
        <Form form={form} variant="dialog" onSubmit={form.handleSubmit(onSubmit)}>
            <ReservationNameTypeDate selectedFromDate={selectedFromDate} setSelectedFromDate={setSelectedFromDate} />
            <ReservationPricing />
            <ReservationStayDetails />
        </Form>
    );
}

export { VersionForm };
